import { ActionHandler, ActionHandlerParams } from "..";
import { completeMainSurvey } from "src/utils/mainSurvey";
import { getPageSetSurvey } from "./util";
import { getCurrentSurveyAnswers } from "src/hooks/survey";

type Params = {
  finishedEvent?: string;
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompleteMainSurvey: ActionHandler = async ({
  params = {},
  pageSet,
  page,
  store,
}: {
  params: Params;
} & ActionHandlerParams): Promise<void> => {
  const survey = getPageSetSurvey(pageSet, page);
  const finishedEvent = params.finishedEvent || `Finished${survey.name}`;

  const currentAnswers = getCurrentSurveyAnswers();
  return completeMainSurvey({
    surveyAnswers: currentAnswers,
    params: {
      ...params,
      surveyNameSpace: survey.surveyNameSpace,
      finishedEvent,
    },
    dispatch: store.dispatch,
  });
};
